import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 4H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 8H6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 12H9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 16h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 20H9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Tornado";
const Tornado = memo(themed(Icon));
export {
  Tornado
};
//# sourceMappingURL=tornado.js.map
